module.exports = __webpack_public_path__ + "assets/img/falcon-tour.db642907.png";